import React from 'react'
import { AuthenticationContext } from '../../../contexts/authentication'

import { apolloClient } from '../../../index'

class Logout extends React.Component {

    static contextType = AuthenticationContext

    componentDidMount = () => {
        apolloClient.resetStore()
        this.context.setAuthenticationStatus()
        this.props.history.push('/')
    }

    render() {
        return ('logging out...')
    }

    
}

export default Logout;